import {createReducer, getType} from "typesafe-actions"

// Models
import {RecordsStateType} from "../../models"

// Actions
import * as a from "../actions"

const InitialRecordsState: RecordsStateType = {
    current: null,
    fetching: false,
    receiveNext: true,
    receiveNextError: null,
    currentSignals: null,
    fetchingSignals: false,
    approveDialogActive: false,
    currentApproving: false,
    updatingConclusion: false,
    isConclusionEditing: false,
    isParameterEditing: false,
    updatingParameters: false,
    updatedParameters: false,
    parametersError: null,
    isInterpretationUpdating: false,
    isInterpretationUpdated: false,
    pdf: null,
    fetchingPDF: false,
    recordApproved: false,
    recordConflict: false,
    //toggleGraph: false,
};

const recordsReducer = createReducer<RecordsStateType>(InitialRecordsState, {
    [getType(a.fetchNextRecordAsync.request)]: state => ({
        ...state,
        fetching: true,
        receiveNextError: null,
        recordApproved: false,
    }),
    [getType(a.fetchNextRecordAsync.failure)]: (state, {payload: receiveNextError}) => ({
        ...state,
        fetching: false,
        receiveNextError,
    }),
    [getType(a.fetchNextRecordAsync.success)]: (state, {payload: current}) => ({
        ...state,
        current,
        recordConflict: false,
        fetching: false,
    }),
    [getType(a.fetchNextRecordByIdAsync.request)]: state => ({
        ...state,
        fetching: true,
        receiveNextError: null,
        recordApproved: false,
    }),
    [getType(a.fetchNextRecordByIdAsync.failure)]: (state, {payload: receiveNextError}) => ({
        ...state,
        fetching: false,
        receiveNextError,
    }),
    [getType(a.fetchNextRecordByIdAsync.success)]: (state, {payload: current}) => ({
        ...state,
        current,
        recordConflict: false,
        fetching: false,
    }),
    [getType(a.fetchInProgressNextRecordByIdAsync.request)]: state => ({
        ...state,
        fetching: true,
        receiveNextError: null,
        recordApproved: false,
    }),
    [getType(a.fetchInProgressNextRecordByIdAsync.failure)]: (state, {payload: receiveNextError}) => ({
        ...state,
        fetching: false,
        receiveNextError,
    }),
    [getType(a.fetchInProgressNextRecordByIdAsync.success)]: (state, {payload: current}) => ({
        ...state,
        current,
        recordConflict: false,
        fetching: false,
    }),
    [getType(a.fetchRecordByIdAsync.request)]: state => ({
        ...state,
        fetching: true,
        receiveNextError: null,
        recordApproved: false,
    }),
    [getType(a.fetchRecordByIdAsync.failure)]: (state, {payload: receiveNextError}) => ({
        ...state,
        fetching: false,
        receiveNextError,
    }),
    [getType(a.fetchRecordByIdAsync.success)]: (state, {payload: current}) => ({
        ...state,
        current,
        recordConflict: false,
        fetching: false,
    }),
    [getType(a.fetchRecordSignalAsync.request)]: state => ({
        ...state,
        fetchingSignals: true,
    }),
    [getType(a.fetchRecordSignalAsync.failure)]: state => ({
        ...state,
        fetchingSignals: false,
    }),
    [getType(a.fetchRecordSignalAsync.success)]: (state, {payload: currentSignals}) => ({
        ...state,
        currentSignals,
        fetchingSignals: false,
    }),
    [getType(a.approveRecordAsync.request)]: state => ({
        ...state,
        currentApproving: true,
        recordApproved: false
    }),
    [getType(a.approveRecordAsync.failure)]: state => ({
        ...state,
        currentApproving: false,
    }),
    [getType(a.approveRecordAsync.success)]: state => ({
        ...state,
        current: null,
        currentSignals: null,
        currentApproving: false,
        approveDialogActive: false,
       // toggleGraph: false,
        recordApproved: true,
    }),
    [getType(a.updateRecordConclusionAsync.request)]: state => ({
        ...state,
        updatingConclusion: true,
        // recordConflict: false, // This was removed in a previous step, which is correct.
    }),
    [getType(a.updateRecordConclusionAsync.failure)]: state => ({
        ...state,
        updatingConclusion: false,
    }),
    [getType(a.updateRecordConclusionAsync.success)]: (state, {payload: conclusion}) => ({
        ...state,
        current: {
            ...state.current!,
            conclusion,
        },
        updatingConclusion: false,
    }),
    [getType(a.setApproveDialogActive)]: (state, {payload: approveDialogActive}) => ({
        ...state,
        approveDialogActive,
    }),
    /*[getType(a.setToggleGraph)]: (state, {payload: toggleGraph}) => ({
        ...state,
        toggleGraph,
    }),*/
    [getType(a.setReceiveNext)]: (state, {payload: receiveNext}) => ({
        ...state,
        receiveNext,
    }),
    [getType(a.toggleConclusionEditing)]: state => ({
        ...state,
        isConclusionEditing: !state.isConclusionEditing,
    }),
    [getType(a.toggleParameterEditing)]: state => ({
        ...state,
        isParameterEditing: !state.isParameterEditing,
    }),
    [getType(a.updateRecordParametersAsync.request)]: state => ({
        ...state,
        updatingParameters: true,
        updatedParameters: false,
        parametersError: null,
        // recordConflict: false, // This was removed in a previous step, which is correct.
    }),
    [getType(a.updateRecordParametersAsync.failure)]: (state, {payload}) => ({
        ...state,
        updatingParameters: false,
        updatedParameters: false,
        parametersError:
            typeof payload === "string"
                ? payload
                : ((payload && payload.message) || null),
    }),
    [getType(a.updateRecordParametersAsync.success)]: (state, {payload: commonParameters}) => ({
        ...state,
        current: {
            ...state.current!,
            commonParameters,
        },
        updatingParameters: false,
        updatedParameters: true,
        parametersError: null,
    }),
    [getType(a.updateRecordInterpretationsAsync.request)]: state => ({
        ...state,
        isInterpretationUpdating: true,
        isInterpretationUpdated: false,
        // recordConflict: false, // This was removed in a previous step, which is correct.
    }),
    [getType(a.updateRecordInterpretationsAsync.failure)]: state => ({
        ...state,
        isInterpretationUpdating: false,
        isInterpretationUpdated: false,
    }),
    [getType(a.updateRecordInterpretationsAsync.success)]: (state, {payload: interpretation}) => ({
        ...state,
        current: {
            ...state.current!,
            interpretation,
        },
        isInterpretationUpdating: false,
        isInterpretationUpdated: true,
    }),
    [getType(a.fetchPDFRecordAsync.request)]: state => ({
        ...state,
        fetchingPDF: true,
    }),
    [getType(a.fetchPDFRecordAsync.success)]: (state, {payload: pdf}) => ({
        ...state,
        pdf,
        fetchingPDF: false,
    }),
    [getType(a.fetchPDFRecordAsync.failure)]: state => ({
        ...state,
        fetchingPDF: false,
    }),
    [getType(a.clearCurrentRecord)]: () => InitialRecordsState,
    [getType(a.recordConflict)]: state => ({
        ...state,
        recordConflict: true
    })
});

export default recordsReducer
